import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// 아이콘 컴포넌트
const PrintingInfoIcon = ({ type }) => {
  return (
    <div className={`printing_info_icon type_${type}`}>
      {type === 'equip' && (
        <svg viewBox="0 0 24 24">
          <rect x="3" y="5" width="18" height="12" rx="2" />
          <line x1="3" y1="13" x2="21" y2="13" />
          <rect x="9" y="18" width="6" height="2" />
        </svg>
      )}
      {type === 'contact' && (
        <svg viewBox="0 0 24 24">
          <path d="M6 4h3l2 4-2 1c.8 2 2.2 3.4 4.2 4.2l1-2 4 2v3c0 1-1 2-2 2C10.5 18.8 5.2 13.5 4 6c0-1 1-2 2-2z" />
        </svg>
      )}
    </div>
  );
};

// 3D프린터 카드 (슬라이드)
const PrintingRoomCard = ({ building, roomName, roomDetail, images, infoList }) => {
  const [current, setCurrent] = useState(0);
  const navigate = useNavigate();
  const hasMulti = images.length > 1;

  const handlePrev = () => setCurrent((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  const handleNext = () => setCurrent((prev) => (prev === images.length - 1 ? 0 : prev + 1));

  const handleReserve = () => {
    navigate('/board/facility/write', { state: { step: 1 } });
  };

  return (
    <div className="printing_room_block">
      {/* 좌측 이미지 + 슬라이드 */}
      <div className="printing_img_group">
        <div className={`printing_img ${images[current]}`} />

        {hasMulti && (
          <>
            <button type="button" className="meeting_slide_btn meeting_slide_prev" onClick={handlePrev}>
              ‹
            </button>
            <button type="button" className="meeting_slide_btn meeting_slide_next" onClick={handleNext}>
              ›
            </button>
          </>
        )}
      </div>

      {/* 우측 */}
      <div className="printing_text_area">
        <div className="printing_top_row">
          <div className="printing_title_group">
            <span className="printing_building">{building}</span>
            <span className="printing_roomname">{roomName}</span>
          </div>

          <div className="printing_top_right">
            <span className="printing_room_detail">{roomDetail}</span>
            {/* <button type="button" className="printing_apply_btn" onClick={handleReserve}>
              신청하기
            </button> */}
          </div>
        </div>

        <div className="printing_info_panel">
          {infoList.map((item, idx) => (
            <div className="printing_info_item" key={idx}>
              <PrintingInfoIcon type={item.type} />
              <div className="printing_info_text">{item.text}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const Printing = () => {
  const [select, setSelect] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  const handleSelect = (num) => {
    if (select === num) setSelect(0);
    else setSelect(num);
  };

  const moveBoard = (cate) => {
    navigate(`/board/${cate}`, { state: { cate } });
  };

  const movePage = (path) => {
    navigate(path);
  };

  const isActive = (path) => (location.pathname === path ? 'active' : '');

  return (
    <div className="sub_wrap">
      <div className="sub_back">
        {/* 상단 배너 */}
        <div className="sub_banner_area printing">
          <div className="sub_banner_back">
            <div className="navi_text">
              <div className="home_icon_sub"></div>
              {'> '}보유시설{' > '}3D프린터
            </div>
            <div className="banner_main_text">3D프린터</div>
          </div>
        </div>

        {/* 상단 드롭다운 네비 */}
        <div className="navi_area">
          <div className="navi_back">
            <div className="navi_box" onClick={() => handleSelect(1)}>
              <div className="navi_main_text">보유시설</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 1 && 'active'}`}>
                <div className="select_row" onClick={() => moveBoard('notice')}>
                  알림 및 소식
                </div>
                <div className="select_row" onClick={() => movePage('/fusionSupportProgram')}>
                  사업분야
                </div>
                <div className="select_row" onClick={() => movePage('/inquiryinfo')}>
                  기업연구동
                </div>
                <div className="select_row" onClick={() => movePage('/meetingroom')}>
                  보유시설
                </div>
                <div className="select_row" onClick={() => movePage('/vision')}>
                  융합원소개
                </div>
              </div>
            </div>

            <div className="navi_box" onClick={() => handleSelect(2)}>
              <div className="navi_main_text">3D프린터</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 2 && 'active'}`}>
                <div className="select_row" onClick={() => movePage('/meetingroom')}>
                  회의실
                </div>
                <div className="select_row" onClick={() => movePage('/computer')}>
                  전산실습실
                </div>
                <div className="select_row" onClick={() => movePage('/printing')}>
                  3D프린터
                </div>
                <div className="select_row" onClick={() => movePage('/arvr')}>
                  AR/VR
                </div>
                <div className="select_row" onClick={() => movePage('/cnc')}>
                  CNC/MCT
                </div>
                <div className="select_row" onClick={() => navigate('/board/facility/write', { state: { step: 1 } })}>
                  시설예약
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 메인 영역 – 컨테이너를 MeetingRoom과 완전 동일하게 */}
        <div className="sub_main_area meetingroom">
          {/* 고정 사이드바 */}
          <aside className="intro_aside_fixed">
            <div className="intro_aside_header">
              <div className="center_box">
                <span>보유시설</span>
                <div className="center_line"></div>
              </div>
            </div>
            <ul className="intro_aside_list">
              <li className={`intro_aside_item ${isActive('/meetingroom')}`} onClick={() => movePage('/meetingroom')}>
                <span>회의실</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/computer')}`} onClick={() => movePage('/computer')}>
                <span>전산실습실</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/printing')}`} onClick={() => movePage('/printing')}>
                <span>3D프린터</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/arvr')}`} onClick={() => movePage('/arvr')}>
                <span>AR / VR</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/cnc')}`} onClick={() => movePage('/cnc')}>
                <span>CNC / MCT</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li
                className={`intro_aside_item ${isActive('/board/facility/write')}`}
                onClick={() => movePage('/board/facility/write')}
              >
                <span>시설예약</span>
                <span className="aside_arrow">&gt;</span>
              </li>
            </ul>
          </aside>

          {/* 컨테이너도 MeetingRoom과 똑같이 meetingroom 클래스 포함 */}
          <div className="meeting_section_back meetingroom">
            <div className="meeting_section_container">
              {/* 타이틀 */}
              <div className="vision_title_box">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">보유시설 - 3D프린터</div>
              </div>

              {/* 205호 카드 */}
              <PrintingRoomCard
                building="3D프린터실"
                roomName="205호"
                roomDetail="205호 3D프린터실"
                images={['p-room-image1', 'p-room-image2']}
                infoList={[
                  { type: 'equip', text: '주요 시설: 3D프린터 7대' },
                  { type: 'contact', text: '사용문의: 041-354-8558' },
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Printing;
